<template>
  <div class="genericResourceBasicFormHost">
    <component
      :is="resolvedComponent"
      v-if="resolvedComponent"
      ref="inner"
      :asset-type="assetType"
      :mode="mode"
      :rule-form="ruleForm"
      @completion-changed="$emit('completion-changed')"
    />
  </div>
</template>

<script>
import { resolveGenericResourceTypeEntry } from './genericResourceFormRegistry'
import { evaluateTypeConfigCompletion } from './genericResourceTypeConfigCompletion'
import GENERIC_RESOURCE_BASIC_FORM_COMPONENTS from './basicForms/index'

export default {
  name: 'GenericResourceBasicFormHost',
  props: {
    assetType: { type: String, default: '' },
    mode: { type: String, default: 'create' },
    ruleForm: { type: Object, default: null },
    /** zip 包要求由 GenericResourceFormShell 基本信息区统一展示 */
    showZipRequirement: { type: Boolean, default: true },
  },
  computed: {
    typeEntry() {
      return resolveGenericResourceTypeEntry(this.assetType)
    },
    resolvedComponent() {
      const name = this.typeEntry && this.typeEntry.basicForm
      return name ? GENERIC_RESOURCE_BASIC_FORM_COMPONENTS[name] : null
    },
  },
  methods: {
    getInner() {
      return this.$refs.inner
    },
    buildExtaPayload() {
      const inner = this.getInner()
      return inner && inner.buildExtaPayload ? inner.buildExtaPayload() : {}
    },
    loadFromExta(exta) {
      const inner = this.getInner()
      if (inner && inner.loadFromExta) {
        inner.loadFromExta(exta)
      }
    },
    validate() {
      const inner = this.getInner()
      if (inner && inner.validate) {
        return inner.validate()
      }
      return Promise.resolve()
    },
    isComplete() {
      const snapshot = this.captureSnapshot()
      return evaluateTypeConfigCompletion(this.assetType, snapshot).complete
    },
    reset() {
      const inner = this.getInner()
      if (inner && inner.reset) {
        inner.reset()
      }
    },
    captureSnapshot() {
      const inner = this.getInner()
      return inner && inner.captureSnapshot ? inner.captureSnapshot() : {}
    },
  },
}
</script>
